import { Link } from "react-router-dom";
const DoctorsGallery = () => {
  const doctors = [
    {
      id: 1,
      name: "Prof. Dr. Andrea Tomeo",
      qualifications: "PhD. MD. MSc. MBA. BSc.",
      position:
        "Director of Education & Medical Compliance PhD in Stem Cells & Regenerative Medicine",
      specialty:
        "Cosmetic Surgeon, Medical Aesthetics, Clinical Anti-Aging Medicine, Regenerative Medicine, Integrated Medicine, and Sexual Well Being",
      nationality: "Italy",
      languages: "English, Italian, Arabic, Spanish, Portuguese",
      imageUrl:
        "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-1-large.jpg",
      profileUrl:
        "/dr-andrea-tomeo/",
    },
    {
      id: 2,
      name: "Dr. Fasiha Fatima",
      qualifications: "MBBS",
      position: "General Practitioner",
      specialty: "GP Aesthetics & Medicine",
      nationality: "Pakistan",
      languages: "English, Urdu, Sindhi",
      imageUrl:
        "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-8-large.jpg",
      profileUrl: "#",
    },
    {
      id: 3,
      name: "Dr. Mohamed Abbas Elhag",
      qualifications: "MBBS - MD - FAAD",
      position: "Specialist Dermatology & Venereology",
      specialty: "Dermatology & Venereology",
      nationality: "Sudan",
      languages: "Arabic, English",
      imageUrl:
        "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-2-large.jpg",
      profileUrl: "#",
    },
    {
      id: 4,
      name: "Dr. Soroush Mazloomi Koohbanani",
      qualifications: "MBBS",
      position: "Aesthetic General Practitioner",
      specialty: "Aesthetic & General Practicing",
      nationality: "Iran",
      languages: "Farsi, Turkish, English",
      imageUrl:
        "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-4-large.jpg",
      profileUrl: "#",
    },
    {
      id: 5,
      name: "Ms. Mayada Magdy",
      qualifications: "",
      position: "Senior Clinical Dietician",
      specialty: "Nutrition Plans, Weight management",
      nationality: "Egypt",
      languages: "Arabic, English",
      imageUrl:
        "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-3-large.jpg",
      profileUrl: "#",
    },
    {
      id: 6,
      name: "Dr. Faris Alkhanafseh",
      qualifications: "",
      position: "Cosmetic Dentist / Implantologist",
      specialty: "Advanced Cosmetic Dentistry & Dental Implants",
      nationality: "",
      languages: "Arabic, English",
      imageUrl:
        "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-10-large.jpg",
      profileUrl: "#",
    },
    {
      id: 7,
      name: "Ms. Eman Hekal",
      qualifications: "DPT",
      position: "Senior Physiotherapist",
      specialty: "Musculoskeletal, Neurological, & Sports Injury",
      nationality: "Egypt",
      languages: "Arabic, English",
      imageUrl:
        "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2024/12/Ms.-Eman-Hekal-Elite-Body-Home-Polyclinic-Dubai-7-large.jpg",
      profileUrl: "#",
    },
    {
      id: 8,
      name: "Ms. Hina Mehmood",
      qualifications: "",
      position: "Physiotherapist / Wellness Coach",
      specialty:
        "Musculoskeletal, Neurological, Sports Injury, Nutrition, Stress Management, Physical, Mental, & Emotional Well-being",
      nationality: "Pakistan",
      languages: "Arabic, English, Urdu, Hindi",
      imageUrl:
        "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-9-large.jpg",
      profileUrl: "#",
    },
    {
      id: 9,
      name: "Ms. Swaleha",
      qualifications: "",
      position: "Clinical Dietician",
      specialty: "PCOS / Female Fertility, Nutrition Plans, Weight management",
      nationality: "India",
      languages: "Hindi, English",
      imageUrl:
        "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-6-large.jpg",
      profileUrl: "#",
    },
    {
      id: 10,
      name: "Ms. Crista Cyrill Apostol",
      qualifications: "",
      position: "Laser Technician",
      specialty: "Advanced Laser Technologies & Skin Rejuvenation",
      nationality: "Philippines",
      languages: "Filipino, English",
      imageUrl:
        "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-12-large.jpg",
      profileUrl: "#",
    },
    {
      id: 11,
      name: "Pavitra",
      qualifications: "",
      position: "Reg. Nurse",
      specialty: "",
      nationality: "",
      languages: "",
      imageUrl: "",
      profileUrl: "#",
    },
    {
      id: 12,
      name: "Ananti",
      qualifications: "",
      position: "Reg. Nurse",
      specialty: "",
      nationality: "",
      languages: "",
      imageUrl: "",
      profileUrl: "#",
    },
  ];

  return (
    <div className="container my-5">
      <h2 className="text-center mb-5 title">
        Meet the Experts: Elite Body Home's Renowned Doctors
      </h2>

      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-2 g-4">
        {doctors.map((doctor) => (
          <div key={doctor.id} className="col">
            <div className="doctor-card h-100">
              <div className="row g-0 h-100">
                {/* Image Column */}
                <div className="col-md-5">
                  {doctor.imageUrl ? (
                    <img
                      src={doctor.imageUrl}
                      alt={doctor.name}
                      className="img-fluid h-100 w-100"
                      style={{ objectFit: "cover" }}
                    />
                  ) : (
                    <div className="h-100 d-flex align-items-center justify-content-center bg-light">
                      <span>No Image Available</span>
                    </div>
                  )}
                </div>

                {/* Details Column */}
                <div className="col-md-7">
                  <div className="card-body p-3">
                    <h5 className="card-title mb-1">{doctor.name}</h5>
                    {doctor.qualifications && (
                      <h6 className="card-subtitle mb-2 text-muted small">
                        {doctor.qualifications}
                      </h6>
                    )}
                    <p className="card-text  small mb-2">{doctor.position}</p>

                    <div className="doctor-info small">
                      <p className="mb-1">
                        <strong>Speciality:</strong> {doctor.specialty || "N/A"}
                      </p>
                      <p className="mb-1">
                        <strong>Nationality:</strong>{" "}
                        {doctor.nationality || "N/A"}
                      </p>
                      <p className="mb-3">
                        <strong>Language:</strong> {doctor.languages || "N/A"}
                      </p>
                    </div>
                    <Link
                      to={doctor.profileUrl}
                      target={doctor.id === 1 ? "_blank" : undefined}
                      className=" w-100 text-white px-4 py-2 rounded-lg"
                      style={{
                        backgroundColor: "#bdaa7d",
                        textDecoration: "none",
                        marginTop: "10px",
                      }}
                    >
                      View More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .doctor-card {
          border: 1px solid rgba(0, 0, 0, 0.125);
          border-radius: 0.5rem;
          overflow: hidden;
          transition: transform 0.2s;
        }

        .doctor-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        .card-title {
          font-size: 1.5rem;
          font-weight: 600;
        }

        .card-subtitle {
          font-size: 1rem;
        }

        .doctor-info {
          color: #6c757d;
        }

        @media (max-width: 768px) {
          .col-md-5 {
            height: 200px;
          }
        }
      `}</style>
    </div>
  );
};

export default DoctorsGallery;
